import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import checkImg from '../../../src/assets/img/check.svg';
import errorImg from '../../../src/assets/img/erroricon.png';
import warningImg from '../../../src/assets/img/warning.png';
import './commonPopup.css';

const CommonPopup = (props) => {
    const history = useHistory();

    const {
        handleClose,
        popupTitle,
        popupMsg,
        popupType,
        popupActionType,
        popupActionValue,
        popupActionPath,
        Confirmation,
    } = props;

    return (
      
            <Modal show={true} onHide={handleClose} centered>
            <Modal.Header /* closeButton */ className="common-head">
              <h2 className='common' >{popupTitle}</h2>
            </Modal.Header>
            <Modal.Body>
            
                    <div className="commam-img">
                        <img
                            className={
                                popupType.toLowerCase() === 'success'
                                    ? 'successImg'
                                    : popupType.toLowerCase() === 'error'
                                        ? 'errorImg'
                                        : 'warningImg'
                            }
                            alt=""
                            src={
                                popupType.toLowerCase() === 'success'
                                    ? checkImg
                                    : popupType.toLowerCase() === 'error'
                                        ? errorImg
                                        : warningImg
                            }
                        />
                    </div>
                    <div className="commam-img">
                        <p>{popupMsg}</p>
                    </div>
               
            </Modal.Body>
            <Modal.Footer className='common-footer'>
                {popupActionType.toLowerCase() === 'confirm' && (
                    <>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary common-btn" onClick={Confirmation}>
                            OK
                        </Button>
                    </>
                )}

                {popupActionType.toLowerCase() === 'redirect' && (
                    <Button variant="primary" onClick={() => history.push(popupActionPath)}>
                        {popupActionValue}
                    </Button>
                )}
                {popupActionType.toLowerCase() === 'close' && (
                    <Button variant="primary" onClick={handleClose}>
                        {popupActionValue}
                    </Button>
                )}
                {popupActionType.toLowerCase() === 'refresh' && (
                    <a className="btn btn-primary" href={popupActionPath}>
                        {popupActionValue}
                    </a>
                )}
            </Modal.Footer>
        </Modal>
    );
};

CommonPopup.propTypes = {
    handleClose: PropTypes.func,
    popupTitle: PropTypes.string,
    popupMsg: PropTypes.string,
    popupType: PropTypes.string,
    popupActionType: PropTypes.string,
    popupActionValue: PropTypes.string,
    popupActionPath: PropTypes.string,
    Confirmation: PropTypes.func,
};

export default CommonPopup;
